var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0L2.5 0.5H0.5C0.2 0.5 0 0.7 0 1C0 1.3 0.2 1.5 0.5 1.5H1.5H6.5H7.5C7.8 1.5 8 1.3 8 1C8 0.7 7.8 0.5 7.5 0.5H5.5L5 0H3ZM0.5 2.5V9C0.5 9.55 0.95 10 1.5 10H6.5C7.05 10 7.5 9.55 7.5 9V2.5H0.5ZM2.5 3.5C2.8 3.5 3 3.7 3 4V8.5C3 8.8 2.8 9 2.5 9C2.2 9 2 8.8 2 8.5V4C2 3.7 2.2 3.5 2.5 3.5ZM5.5 3.5C5.8 3.5 6 3.7 6 4V8.5C6 8.8 5.8 9 5.5 9C5.2 9 5 8.8 5 8.5V4C5 3.7 5.2 3.5 5.5 3.5Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.5ab26ce3dd0d434a25e3bc7a01c452a3.svg";
export { ForwardRef as ReactComponent };